import Vue from "vue";
import VueRouter from "vue-router";
import { isAuthenticated } from "@/plugins/helpers";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: { name: "home" },
  },
  {
    path: "/",
    redirect: { name: "home" },
    component: () => import("@/layouts/home"),
    meta: {
      requireAuth: false,
    },
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/landing/Home"),
      },
      {
        path: "partners",
        name: "partners",
        component: () => import("@/views/landing/Partners"),
      },
      {
        path: "team",
        name: "team",
        component: () => import("@/views/landing/Team"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// beforeEach for each route when run
router.beforeEach((to, from, next) => {
  // check meta data that requireAuth or not
  const requireAuth = to.matched.some(
    (childRoute) => childRoute.meta.requireAuth
  );
  // check Authenticate if having
  if (requireAuth && !isAuthenticated()) {
    next({ name: "login" });
  } else {
    if (to.name == "login" && isAuthenticated()) {
      next({ name: "home" });
    }
    next();
  }
});

export default router;
